// extracted by mini-css-extract-plugin
module.exports = {"root":"Hero_root__wMgKl","left":"Hero_left__YAIM9","right":"Hero_right__VlVyu","buttons":"Hero_buttons__MtS4O","buttonSpacer":"Hero_buttonSpacer__U0l5T"};